export default {
  ADD_CHIEFS (state, data) {
    state.chiefs = data
  },
  ADD_DEPARTMENT_CHIEF (state, chief) {
    state.chiefs.push(chief)
  },
  UPDATE_CHIEF (state, chief) {
    Object.assign(state.chiefs.find(c => c.id === chief.id), chief)
  },
  DELETE_CHIEF (state, id) {
    state.chiefs = state.chiefs.filter(c => c.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/departments.js